import {
    omit,
} from 'lodash'
import removeEmptyFields from 'app/utils/removeEmptyFields'
import {
    TableFilterParams,
} from 'app/types/common.types'

const getAppliedFilterParams = (setAppliedFilterParams: (data: TableFilterParams) => void) => {
    return (cb) => {
        return (params) => {
            setAppliedFilterParams({
                ...omit(params, [
                    'filter',
                    'typeMapping',
                    'page',
                    'sort',
                    'urlQuery',
                ]),
                includeFilters: removeEmptyFields(params.filter),
            })
            return cb(params)
        }
    }
}

export default getAppliedFilterParams
